export const NEED_TO_LOGOUT_VERSION = "LOGOUT_VERSION"
export const BACKEND_VERSION = "BACKEND_VERSION"
export const FRONTEND_VERSION = "FRONTEND_VERSION"
export const SAVED_ADDRESS = "savedAddress"
